// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.facilityGroupModal__gLWDD {
  width: 720px;
  height: 650px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.modalInfoLine__EkRlu {
  font-size: 11px;
  font-weight: 400;
  line-height: 14px;
  text-align: left;
  text-transform: uppercase;
  color: var(--tables-title-text);
  padding: 6px 25px;
  border-top: 1px solid var(--tables-title-stroke);
  border-bottom: 1px solid var(--tables-title-stroke);
  background: var(--tables-title-surface);
}

.modalBody__aBAve {
  height: 100%;
  padding: 25px 25px 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  row-gap: 8px;
}

.facilitiesBlock__hXGtw {
  display: flex;
  flex-direction: column;
  row-gap: 5px;
}

.facilitiesBlockLabel__wX1qx {
  font-size: 11px;
  line-height: 14px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
}
.facilitiesBlockLabel__wX1qx:after {
  content: "*";
  font-size: 10px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-left: 5px;
}

.helperText__qG8is {
  font-size: 11px;
  line-height: 12px;
  color: var(--inputs-error-text-helper);
  margin-top: 5px;
  min-height: 12px;
}
@media (max-width: 850px) {
  .helperText__qG8is {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}

.modalFooter__riyEI {
  display: grid;
  grid-template-columns: repeat(2, 100px);
  justify-content: flex-end;
  align-items: center;
  column-gap: 10px;
  padding: 0 25px 25px;
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/CreateEditFacilityGroupModal/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,+BAAA;EACA,iBAAA;EACA,gDAAA;EACA,mDAAA;EACA,uCAAA;AAzEF;;AA4EA;EACE,YAAA;EACA,oBAAA;EACA,aAAA;EACA,OAAA;EACA,sBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAzEF;;AA4EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;AAzEF;AA2EE;EACE,YAAA;EACA,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,gBAAA;AAzEJ;;AA6EA;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;AA1EF;AA4EE;EAPF;IAQI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EAzEF;AACF;;AA4EA;EACE,aAAA;EACA,uCAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,oBAAA;AAzEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.facilityGroupModal {\n  width: 720px;\n  height: 650px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n}\n\n.modalInfoLine {\n  font-size: 11px;\n  font-weight: 400;\n  line-height: 14px;\n  text-align: left;\n  text-transform: uppercase;\n  color: var(--tables-title-text);\n  padding: 6px 25px;\n  border-top: 1px solid var(--tables-title-stroke);\n  border-bottom: 1px solid var(--tables-title-stroke);\n  background: var(--tables-title-surface);\n}\n\n.modalBody {\n  height: 100%;\n  padding: 25px 25px 0;\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  row-gap: 8px;\n}\n\n.facilitiesBlock {\n  display: flex;\n  flex-direction: column;\n  row-gap: 5px;\n}\n\n.facilitiesBlockLabel {\n  font-size: 11px;\n  line-height: 14px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n\n  &:after {\n    content: '*';\n    font-size: 10px;\n    line-height: 12px;\n    color: var(--inputs-error-text-helper);\n    margin-left: 5px;\n  }\n}\n\n.helperText {\n  font-size: 11px;\n  line-height: 12px;\n  color: var(--inputs-error-text-helper);\n  margin-top: 5px;\n  min-height: 12px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n\n.modalFooter {\n  display: grid;\n  grid-template-columns: repeat(2, 100px);\n  justify-content: flex-end;\n  align-items: center;\n  column-gap: 10px;\n  padding: 0 25px 25px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"facilityGroupModal": `facilityGroupModal__gLWDD`,
	"modalInfoLine": `modalInfoLine__EkRlu`,
	"modalBody": `modalBody__aBAve`,
	"facilitiesBlock": `facilitiesBlock__hXGtw`,
	"facilitiesBlockLabel": `facilitiesBlockLabel__wX1qx`,
	"helperText": `helperText__qG8is`,
	"modalFooter": `modalFooter__riyEI`
};
module.exports = ___CSS_LOADER_EXPORT___;
